import {IExpert} from "../types/IExpertOpinion";

const expertImg = require("../images/expert.png");

export const DEFAULT_EXPERT: IExpert = {
    img: expertImg,
    name: "Marek Wielgo",
    type: "Ekspert rynku nieruchomości rynekpierwotny.pl / GetHome.pl"
};
import {IExpert} from "../types/IExpertOpinion";

const expertImg = require("../images/expert.png");

export const DEFAULT_EXPERT: IExpert = {
    img: expertImg,
    name: "Marek Wielgo",
    type: "Ekspert rynku nieruchomości rynekpierwotny.pl / GetHome.pl"
};
